// @ts-ignore
import env from "configs/env"

const domain = (() => {
   switch (env.TARGET_ENV) {
      case "production":
         return ".rentpost.com"
      case "stage":
         return ".stage.rentpost.com"
      case "development":
         return ".rentpost.test"
      default:
         return ".rentpost.test"
   }
})()

const UTMCookies = {
   get: () => {
      const cookies = document.cookie.split(";")
      const cookie = cookies.find((cookie) => cookie.includes("referrer"))
      const cookieValue = cookie?.split("referrer=")[1]
         ? JSON.parse(cookie.split("referrer=")[1])
         : null
      const referrer = {
         url: cookieValue?.url || "",
         utm_source: cookieValue?.utm_source || "",
         utm_medium: cookieValue?.utm_medium || "",
         utm_campaign: cookieValue?.utm_campaign || "",
         utm_term: cookieValue?.utm_term || "",
         utm_content: cookieValue?.utm_content || "",
      }
      return referrer
   },
   remove: (): void => {
      document.cookie = `referrer=; path=/; domain=${domain}; secure=true; samesite=lax; expires=Thu, 01 Jan 1970 00:00:00 GMT`
   },
}

export default UTMCookies
